import React, { useState } from "react";
import { Undo2, Loader2 } from "lucide-react";
import { useLang } from "../context/LanguageContext";

// One-tap "Undo" for reversible actions (unfollow a shop or plaza, delete a saved search).
export const UndoAction = ({ onUndo, testid = "undo-action" }) => {
  const { t } = useLang();
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const click = async () => {
    setBusy(true);
    try { await onUndo(); setDone(true); } finally { setBusy(false); }
  };

  return (
    <button onClick={click} disabled={busy || done} data-testid={testid}
      className="shrink-0 inline-flex items-center gap-1.5 text-xs font-bold rounded-xl px-3 py-2 bg-[#16a34a] hover:bg-[#15803d] disabled:opacity-70 text-white transition-colors">
      {busy ? <Loader2 size={13} className="animate-spin" /> : <Undo2 size={13} />}
      {done ? t("undo.done") : t("undo.label")}
    </button>
  );
};

export default UndoAction;
